import { WarehouseContactTabProps } from "./types";
import { memo, useCallback, useState } from "react";
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { Dialog } from "ui/components/Dialog";
import { Loader } from "ui/components/Loader";
import { TableSearch } from "ui/components/Table/TableSearch";
import { getContactAPI } from "services/api/contacts/api";
import { WAREHOUSE_EDIT_CONTACT_COLUMNS } from "./consts";

/**
 * Korak kontakata skladišta: isti izgled kao predstavnici u čarobnjaku kontakta. Odabir kontakta
 * ga odmah dodaje na skladište, a kanta ga uklanja.
 */
const WarehouseContactTab: React.FC<WarehouseContactTabProps> = (props) => {
  const { formValues, setFormValues } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deleteContactId, setDeleteContactId] = useState<string | null>(null);

  const contacts = formValues.contacts;

  const handleContactChange = useCallback(
    async (_e: any, _name: string, item: DropdownOption) => {
      const contactId = item.value;
      if (!contactId || contacts.some((contact) => contact.id === contactId)) return;

      setIsLoading(true);
      try {
        const contact = await getContactAPI(contactId);
        if (contact) {
          setFormValues((prev) => ({ ...prev, contacts: [...prev.contacts, contact] }));
        }
      } catch {
        // greška se prikazuje kroz snackbar
      }
      setIsLoading(false);
    },
    [contacts, setFormValues]
  );

  // Klik na kantu ne smije pokrenuti i klik na redak.
  const handleDeleteClick = useCallback((event: React.MouseEvent<HTMLDivElement>, contactId: string) => {
    event.stopPropagation();
    event.preventDefault();
    setDeleteContactId(contactId);
  }, []);

  const handleDeleteConfirm = useCallback(() => {
    setFormValues((prev) => ({
      ...prev,
      contacts: prev.contacts.filter((contact) => contact.id !== deleteContactId),
    }));
    setDeleteContactId(null);
  }, [deleteContactId, setFormValues]);

  const handleDeleteCancel = useCallback(() => {
    setDeleteContactId(null);
  }, []);

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">Kontakti</h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Odaberite osobe ili tvrtke zadužene za ovo skladište.
          Nakon unosa možete spremiti skladište.
        </p>

        <div className="px-3">
          <div className="mb-4">
            <ContactDropdown
              name="contactId"
              label="Odaberite kontakt"
              placeholder="Pretraži kontakte..."
              value={null}
              onChange={handleContactChange}
            />
          </div>

          {contacts.length > 0 && (
            <div className="relative">
              <TableSearch
                columns={WAREHOUSE_EDIT_CONTACT_COLUMNS(handleDeleteClick)}
                data={contacts}
                selectableRows={false}
                disablePagination
              />
            </div>
          )}
          <Loader isLoading={isLoading}> </Loader>
        </div>
      </div>

      <Dialog
        open={!!deleteContactId}
        title="Uklanjanje kontakta"
        message="Jeste li sigurni da želite ukloniti kontakt sa skladišta?"
        confirmText="Ukloni"
        cancelText="Odustani"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
      />
    </div>
  );
};
export default memo(WarehouseContactTab);
